<article class="authPage">
  <div
    class="authPage__background"
    data-testid="authPageBackground"
  ></div>
  <section class="authPage__content">
    @if (!ppHideLogo) {
      <h1 class="authPage__title">
        <pp-brand-logo class="authPage__logo" [ppFallback]="EIconPath.LOGO"></pp-brand-logo>
      </h1>
    }
    <ng-content></ng-content>
  </section>
</article>
